module.exports = __webpack_public_path__ + "static/media/card_empty.f05c1837.png";